import React, { Component } from 'react'
import { Carousel, Container } from 'react-bootstrap'
import i2 from '../jpgforpage/2016/i2.jpg'
import kDLmyNEnoU from '../jpgforpage/2016/kDLmyNEnoU.jpg'
import i28 from '../jpgforpage/2016/i28.jpg'
import i39 from '../jpgforpage/2016/i39.jpg'
import i71 from '../jpgforpage/2016/i71.jpg'
import DSC_0773 from '../jpgforpage/2016/DSC_0773.JPG'
import DSC_0841 from '../jpgforpage/2016/DSC_0841.JPG'
import DSC_0846 from '../jpgforpage/2016/DSC_0846.JPG'
import DAWjY_tMsvA from '../jpgforpage/2016/DAWjY_tMsvA.jpg'



export default class Photo2016 extends Component {
    render() {
        return (
            <Container>
                <Carousel>
                    <Carousel.Item>
                        <img 
                            src={i2}
                            className='img-carousel-1'
                            alt="Photo2016"
                        />
                        <Carousel.Caption>
                            <p>Вручення дипломів 2016 (магістри)</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={kDLmyNEnoU} 
                            className='img-carousel-1'
                            alt="Photo2016"
                        />
                        <Carousel.Caption>
                            <p>Вручення дипломів 2016 (магістри)</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={i28} 
                            className='img-carousel-1'
                            alt="Photo2016"
                        />
                        <Carousel.Caption>
                            <p>Вручення дипломів 2016 (магістри)</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={i39} 
                            className='img-carousel-1'
                            alt="Photo2016"
                        />
                        <Carousel.Caption>
                            <p>Вручення дипломів 2016 (магістри)</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={i71} 
                            className='img-carousel-1'
                            alt="Photo2016"
                        />
                        <Carousel.Caption>
                            <p>Вручення дипломів 2016 (магістри)</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={DSC_0773} 
                            className='img-carousel-1'
                            alt="Photo2016"
                        />
                        <Carousel.Caption>
                            <p>Вручення дипломів 2016 (магістри)</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={DSC_0841}
                            className='img-carousel-1'
                            alt="Photo2016"
                        />
                        <Carousel.Caption>
                            <p>Вручення дипломів 2016 (магістри)</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={DAWjY_tMsvA}
                            className='img-carousel-1'
                            alt="Photo2016"
                        />
                        <Carousel.Caption>
                            <p>Вручення дипломів 2016 (магістри)</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={DSC_0846}
                            className='img-carousel-1'
                            alt="Photo2016"
                        />
                        <Carousel.Caption>
                            <p>Вручення дипломів 2016 (магістри)</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                </Carousel> <hr />
            </Container>
           )
       }
   }
   
         